// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3I9Jg","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1jElz","obliqueLine":"membershipbadge_obliqueLine__3XV8d"};